import React from 'react';
import {FieldProp} from '../../types';

type HiddenProps = FieldProp;

export const Hidden: React.FunctionComponent<HiddenProps> = ({
                                                                 field,
                                                                 value,
                                                             }): JSX.Element => {
    return (
        <div>
            <input
                id={field.htmlId}
                type="hidden"
                value={value || ''}
            />
        </div>
    );
};
